// CreateRoleConfig.js
import * as yup from "yup";

export const schema = [
  yup.object({
    name: yup
      .string()
      .required("Please provide the role name")
      .max(50, "Role name cannot exceed 50 characters")
      .matches(/^[A-Za-z0-9 ]+$/, "Role name can only contain letters, numbers, and spaces"),

    // Make User Access Type mandatory - at least one option must be selected
    "User Acess Type": yup
      .object()
      .test('at-least-one', 'Please select at least one access type (Web or Mobile)', function(value) {
        return value && (value.web === true || value.mobile === true);
      })
      .required("User access type is required"),

    // Web permission - required when web access is enabled
    permission: yup
      .string()
      .test('web-permission-required', 'Web permissions are required when Web access is enabled', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.web === true) {
          return value && value.trim() !== "";
        }
        return true;
      })
      .test('web-permission-clear', 'Please clear web permissions before disabling Web access', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.web === false && value && value.trim() !== "") {
          return false;
        }
        return true;
      }),

    // Mobile permission - required when mobile access is enabled
    Mobile_permission: yup
      .array()
      .nullable()
      .test('mobile-permission-required', 'Mobile permissions are required when Mobile access is enabled', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.mobile === true) {
          return value && value.length > 0;
        }
        return true;
      })
      .test('mobile-permission-clear', 'Please clear mobile permissions before disabling Mobile access', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.mobile === false && value && value.length > 0) {
          return false;
        }
        return true;
      }),

    // Optional description field
    description: yup.string().max(250, "Description cannot exceed 250 characters")
  })
];

export const CreateRoleConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "name",
        label: "roleformlabels.name",
        type: "input",
        mandatory: "true"
      },
      {
        name: "User Acess Type",
        type: "checkboxmultiGroup",
        label: "Select Permissions",
        parentLabel: "User Access Media",
        mandatory: "true",
        options: [
          { name: "web", label: "Web", value: "W" },
          { name: "mobile", label: "Mobile", value: "M" },
        ],
      },
      {
        name: "permission",
        containerId: "container_web_permission",
        label: "Web Permission",
        type: "hier_select_for_role",
        mandatory: "conditional"
      },
      {
        name: "Mobile_permission",
        label: "Mobile Permission",
        containerId: "container_mobile_permission",
        type: "multi_select_role",
        mandatory: "conditional"
      },
      {
        name: "description",
        label: "roleformlabels.description",
        type: "text_area"
      }
    ]
  }
];